import React from "react";
import { MdReceiptLong } from "react-icons/md";
import { HiChevronRight } from "react-icons/hi2";
import {
  LuClock3,
  LuPackageCheck,
  LuCheckCircle2,
  LuXCircle,
  LuHourglass,
} from "react-icons/lu";
import { ReserveListContainer } from "../styled/selfService";

const STATUS_META = {
  READY: {
    label: "대기중",
    className: "ready",
    icon: LuClock3,
  },
  COMPLETED: {
    label: "보관중",
    className: "completed",
    icon: LuPackageCheck,
  },
  RETRIEVED: {
    label: "찾기완료",
    className: "retrieved",
    icon: LuCheckCircle2,
  },
  CANCELED: {
    label: "취소됨",
    className: "canceled",
    icon: LuXCircle,
  },
  EXPIRED: {
    label: "만료",
    className: "expired",
    icon: LuHourglass,
  },
};

const getStatusMeta = (status) => {
  return (
    STATUS_META[status] || {
      label: status || "-",
      className: "default",
      icon: LuClock3,
    }
  );
};

const ReserveList = ({
  transformValue,
  reserves = [],
  selectedReserve,
  setSelectedReserve,
  onSelectReserve,
}) => {
  return (
    <ReserveListContainer
      className="slideContent"
      style={{ transform: `translateX(${transformValue}%)` }}
    >
      <div className="reserveWrap">
        <div className="topBox">
          <div className="titleRow">
            <div className="titleBadge">
              <MdReceiptLong />
            </div>

            <div className="titleTextBox">
              <div className="title">예약 내역 선택</div>
              <div className="sub">찾을 예약을 선택해주세요</div>
            </div>
          </div>

          <div className="guidePill">예약 카드 한 번 터치로 바로 선택됩니다</div>
        </div>

        <div className="listBox">
          {reserves.length > 0 ? (
            <ul>
              {reserves.map((item, index) => {
                const reserveNo = item.reserveId ?? item.id ?? "-";
                const day = item.reservationDay ?? "-";
                const time = item.reservationStartTime ?? "-";
                const rawStatus = item.reservationStatus ?? "-";

                const statusMeta = getStatusMeta(rawStatus);
                const StatusIcon = statusMeta.icon;

                const currentId = item.reserveId ?? item.id;
                const selectedId = selectedReserve?.reserveId ?? selectedReserve?.id;
                const isActive = selectedId === currentId;

                return (
                  <li key={`${currentId}-${reserveNo}-${index}`}>
                    <button
                      type="button"
                      className={`reserveCard ${isActive ? "active" : ""}`}
                      onClick={() => {
                        setSelectedReserve(item);
                        onSelectReserve?.(item);
                      }}
                    >
                      <span className="cardGlow" />

                      <div className="left">
                        <div className="iconBox">
                          <MdReceiptLong />
                        </div>

                        <div className="textBox">
                          <div className="main">
                            <span className="label">예약번호</span>
                            <strong>{reserveNo}</strong>
                          </div>

                          <div className="subText">
                            <span>{day}</span>
                            <span className="dot" />
                            <span>{time}</span>
                          </div>
                        </div>
                      </div>

                      <div className="right">
                        <span className={`status ${statusMeta.className}`}>
                          <StatusIcon />
                          <span>{statusMeta.label}</span>
                        </span>

                        <span className={`arrow ${isActive ? "active" : ""}`}>
                          <HiChevronRight />
                        </span>
                      </div>
                    </button>
                  </li>
                );
              })}
            </ul>
          ) : (
            <div className="empty">
              <div className="emptyIcon">
                <MdReceiptLong />
              </div>
              <div className="emptyTitle">조회된 예약 내역이 없습니다</div>
              <div className="emptySub">전화번호와 비밀번호를 다시 확인해주세요</div>
            </div>
          )}
        </div>
      </div>
    </ReserveListContainer>
  );
};

export default ReserveList;